module.exports = __webpack_public_path__ + "img/mostly_cloudy.3784af72.svg";